// src/routes/RoutesConfig.js
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import PublicRoutes from './PublicRoutes';
import AdminRoutes from './AdminRoutes';

const RoutesConfig = ({ userRole, sliderData, onLogout }) => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/*" element={<PublicRoutes sliderData={sliderData} />} />

      {/* Admin Routes */}
      <Route
        path="/admin/*"
        element={<AdminRoutes userRole={userRole} onLogout={onLogout} />}
      />

      {/* Fallback Route: Redirect unmatched paths to home */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default RoutesConfig;